import { on } from 'delegated-events';
import { throttle } from 'lodash';

export default (function () {
  return {
    init() {
	  window.addEventListener('load', this.openMenu);
	  window.addEventListener('load', this.openSearch);
	  window.addEventListener('load', this.checkForParentItems);
	  window.addEventListener('load', this.checkForChildrenItems);
	  window.addEventListener('load', this.openSubnav);
    },
    openMenu() {
      const menuToggle = document.querySelectorAll('.js-launch-nav');
      const bottomMenu = document.querySelector('.nav__bottom');
      [...menuToggle].forEach((toggler) => {
        toggler.addEventListener('click', (e) => {
          e.target.classList.toggle('btn--icon--close');
          bottomMenu.classList.toggle('nav__bottom--open');
          document.body.classList.toggle('menu-open');
        });
      });
    },
    openSubnav() {
      const subNavOpen = document.querySelectorAll('.js-subnav-open');
      const navGlobalItems = document.querySelector('.nav__global');

      if (subNavOpen.length === 0) return;

      if (window.innerWidth <= 1024) {
        on('click', '.js-subnav-open', (e) => {
          if (e.target.classList.contains('js-subnav-toggler')) {
			  e.preventDefault();
			  const self = e.target;
			  const parent = self.parentNode;
			  const subNav = parent.querySelector('.js-subnav');
			  if (subNav) {
              subNav.classList.toggle('nav__sub--open');
              parent.classList.toggle('nav__item--open');
              navGlobalItems.classList.toggle('nav__global--hidden');
			  }
          } else if (e.target.classList.contains('js-nav-back')) {
			  const subNav = e.target.parentNode.children[e.target.parentNode.children.length - 1];
			  const parent = e.target.parentNode;
			  subNav.classList.remove('nav__sub--open');
			  parent.classList.remove('nav__item--open');
			  navGlobalItems.classList.remove('nav__global--hidden');
          }
        });
      }
    },
    openSearch() {
      const searchContainer = document.querySelector('.search');
      const menuToggle = document.querySelector('.js-launch-nav');
      const bottomMenu = document.querySelector('.nav__bottom');
      on('click', '.js-launch-search', (e) => {
        e.preventDefault();
        e.target.classList.toggle('btn--icon--close--white');
        searchContainer.classList.toggle('search--open');

        menuToggle.classList.remove('btn--icon--close');
        bottomMenu.classList.remove('nav__bottom--open');
        document.body.classList.remove('menu-open');
      });
    },

    checkForParentItems() {
      const subNavList = document.querySelectorAll('.nav__sub-list');

      subNavList.forEach((subnav) => {
        if (subnav.querySelectorAll('.nav__sub-title').length === 0) {
          const items = subnav.querySelectorAll('.nav__sub-item');
          items.forEach((item) => {
            item.classList.remove('nav__sub-item--child');
          });
        }
      });
    },

    checkForChildrenItems() {
      const subNavOpenItems = document.querySelectorAll('.js-subnav-open');

      subNavOpenItems.forEach((item) => {
        const subNavMenu = item.querySelector('.js-subnav');
        const subNavButtons = item.querySelectorAll('.btn');
        if (subNavMenu === null) {
          subNavButtons.forEach((btn) => {
            btn.remove();
          });
        }
      });
    },
  };
})();
